export const FILTER_NAMES = {
  Basic: {
    'Well Drop Score.Group Name': {
      label: 'Score Group',
      operator: '=',
    },
    'Well Drop Score.Name': {
      label: 'Score',
      operator: '=',
    },
    'Capture Result.Profile Name': {
      label: 'Imaging Setting',
      operator: '=',
    },
    'Capture Result.Date Imaged': {
      label: 'Older Than (Days)',
      operator: '<',
    },
    'Image.Type Short Name': {
      label: 'Image Type',
      operator: '=',
    },
    'Plate.Plate State': {
      label: 'Plate State',
      operator: '=',
    },
    'Inspection.Position': {
      label: 'Inspection',
      operator: '=',
    },
  },
  Advanced: {
    'Capture Result.ID': {
      label: 'Capture Result ID',
      group: 'Capture Result',
    },
    'Capture Result.Image Batch ID': {
      label: 'Capture Result Image Batch ID',
      group: 'Capture Result',
    },
    'Capture Result.Profile ID': {
      label: 'Capture Result Profile ID',
      group: 'Capture Result',
    },
    'Capture Result.Profile Name': {
      label: 'Capture Result Profile Name',
      group: 'Capture Result',
    },
    'Capture Result.Date Imaged': {
      label: 'Capture Result Date Imaged',
      group: 'Capture Result',
    },

    'Experiment.Date Prepared': {
      label: 'Experiment Date Prepared',
      group: 'Experiment',
    },
    'Experiment.Incubation Temp.': {
      label: 'Experiment Incubation Temperature',
      group: 'Experiment',
    },
    'Experiment.ID': {
      label: 'Experiment ID',
      group: 'Experiment',
    },
    'Experiment.Name': {
      label: 'Experiment Name',
      group: 'Experiment',
    },
    'Experiment.Notebook Page Number': {
      label: 'Experiment Notebook Page Number',
      group: 'Experiment',
    },
    'Experiment.Notes': {
      label: 'Experiment Notes',
      group: 'Experiment',
    },
    'Experiment.Owner': {
      label: 'Experiment Owner',
      group: 'Experiment',
    },
    'Experiment.Seeding': {
      label: 'Experiment Seeding',
      group: 'Experiment',
    },
    'Experiment.Setup Temp.': {
      label: 'Experiment Setup Temperature',
      group: 'Experiment',
    },

    'Experiment Plate.Date Dispensed': {
      label: 'Experiment Plate Date Dispensed',
      group: 'Experiment Plate',
    },
    'Experiment Plate.ID': {
      label: 'Experiment Plate ID',
      group: 'Experiment Plate',
    },
    'Experiment Plate.Name': {
      label: 'Experiment Plate Name',
      group: 'Experiment Plate',
    },
    'Experiment Plate.Notes': {
      label: 'Experiment Plate Notes',
      group: 'Experiment Plate',
    },
    'Experiment Plate.Number': {
      label: 'Experiment Plate Number',
      group: 'Experiment Plate',
    },
    'Experiment.Plate Type': {
      label: 'Experiment Plate Type',
      group: 'Experiment Plate',
    },
    'Experiment Plate.Barcode': {
      label: 'Experiment Plate Barcode',
      group: 'Experiment Plate',
    },

    'Image.File Size': {
      label: 'Image File Size',
      group: 'Image',
    },
    'Image.ID': {
      label: 'Image ID',
      group: 'Image',
    },
    'Image.Pixel Size': {
      label: 'Image Pixel Size',
      group: 'Image',
    },
    'Image.Store Base Path': {
      label: 'Image Store Base Path',
      group: 'Image',
    },
    'Image.Store ID': {
      label: 'Image Store ID',
      group: 'Image',
    },
    'Image.Store Name': {
      label: 'Image Store Name',
      group: 'Image',
    },
    'Image.Type ID': {
      label: 'Image Type ID',
      group: 'Image',
    },
    'Image.Type Index': {
      label: 'Image Type Index',
      group: 'Image',
    },
    'Image.Type Long Name': {
      label: 'Image Type Long Name',
      group: 'Image',
    },
    'Image.Type Short Name': {
      label: 'Image Type Short Name',
      group: 'Image',
    },

    'Protein Formulation.Class': {
      label: 'Protein Formulation Class',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Date Prepared': {
      label: 'Protein Formulation Date Prepared',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Extinction Coefficient': {
      label: 'Protein Formulation Extinction Coefficient',
      group: 'Protein Formulation',
    },
    'Protein Formulation.ID': {
      label: 'Protein Formulation ID',
      group: 'Protein Formulation',
    },
    'Protein Formulation Ingredient.Conc. mg/mL': {
      label: 'Protein Formulation Ingredient Conc. mg/mL',
      group: 'Protein Formulation',
    },
    'Protein Formulation Ingredient.Conc. mM': {
      label: 'Protein Formulation Ingredient Conc. mM',
      group: 'Protein Formulation',
    },
    'Protein Formulation Ingredient.Lot': {
      label: 'Protein Formulation Ingredient Lot',
      group: 'Protein Formulation',
    },
    'Protein Formulation Ingredient.Molecular Weight': {
      label: 'Protein Formulation Ingredient Molecular Weight',
      group: 'Protein Formulation',
    },
    'Protein Formulation Ingredient.Name': {
      label: 'Protein Formulation Ingredient Name',
      group: 'Protein Formulation',
    },
    'Protein Formulation Ingredient.Type': {
      label: 'Protein Formulation Ingredient Type',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Name': {
      label: 'Protein Formulation Name',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Notebook Page Number': {
      label: 'Protein Formulation Notebook Page Number',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Notes': {
      label: 'Protein Formulation Notes',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Protein Lot ID': {
      label: 'Protein Formulation Protein Lot ID',
      group: 'Protein Formulation',
    },
    'Protein Formulation Standard Ingredient.Concentration': {
      label: 'Protein Formulation Standard Ingredient Concentration',
      group: 'Protein Formulation',
    },
    'Protein Formulation Standard Ingredient.Concentration Units': {
      label: 'Protein Formulation Standard Ingredient Concentration Units',
      group: 'Protein Formulation',
    },
    'Protein Formulation Standard Ingredient.Long Name': {
      label: 'Protein Formulation Standard Ingredient Long Name',
      group: 'Protein Formulation',
    },
    'Protein Formulation Standard Ingredient.pH': {
      label: 'Protein Formulation Standard Ingredient pH',
      group: 'Protein Formulation',
    },
    'Protein Formulation Standard Ingredient.Type': {
      label: 'Protein Formulation Standard Ingredient Type',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Storage Temp.': {
      label: 'Protein Formulation Storage Temperature',
      group: 'Protein Formulation',
    },
    'Protein Formulation.Volume': {
      label: 'Protein Formulation Volume',
      group: 'Protein Formulation',
    },

    'Region Annotation.ID': {
      label: 'Region Annotation ID',
      group: 'Region',
    },
    'Region Annotation.Text': {
      label: 'Region Annotation Text',
      group: 'Region',
    },
    'Region Annotation.Type Icon': {
      label: 'Region Annotation Type Icon',
      group: 'Region',
    },
    'Region Annotation.Type ID': {
      label: 'Region Annotation Type ID',
      group: 'Region',
    },
    'Region Annotation.Type Name': {
      label: 'Region Annotation Type Name',
      group: 'Region',
    },
    'Region.ID': {
      label: 'Region ID',
      group: 'Region',
    },
    'Region.Name': {
      label: 'Region Name',
      group: 'Region',
    },
    'Region.Type ID': {
      label: 'Region Type ID',
      group: 'Region',
    },
    'Region.Type Name': {
      label: 'Region Type Name',
      group: 'Region',
    },

    'Well Drop.ID': {
      label: 'Well Drop ID',
      group: 'Well Drop',
    },
    'Well Drop.Number': {
      label: 'Well Drop Number',
      group: 'Well Drop',
    },
    'Well Drop.Protein Volume': {
      label: 'Well Drop Protein Volume',
      group: 'Well Drop',
    },
    'Well Drop Score.Date Imaged': {
      label: 'Well Drop Score Date Imaged',
      group: 'Well Drop',
    },
    'Well Drop Score.Group Name': {
      label: 'Well Drop Score Group Name',
      group: 'Well Drop',
    },
    'Well Drop Score.Hot Key': {
      label: 'Well Drop Score Hot Key',
      group: 'Well Drop',
    },
    'Well Drop Score.Name': {
      label: 'Well Drop Score Name',
      group: 'Well Drop',
    },
    'Well Drop Score.Score Value': {
      label: 'Well Drop Score Score Value',
      group: 'Well Drop',
    },
    'Well Drop.Well Volume': {
      label: 'Well Drop Well Volume',
      group: 'Well Drop',
    },

    'Well Ingredient.Concentration': {
      label: 'Well Ingredient Concentration',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Concentration Units': {
      label: 'Well Ingredient Concentration Units',
      group: 'Well Ingredient',
    },
    'Well Ingredient.High pH Volume': {
      label: 'Well Ingredient High pH Volume',
      group: 'Well Ingredient',
    },
    'Well Ingredient.ID': {
      label: 'Well Ingredient ID',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Long Name': {
      label: 'Well Ingredient Long Name',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Low pH Volume': {
      label: 'Well Ingredient Low pH Volume',
      group: 'Well Ingredient',
    },
    'Well Ingredient.pH': {
      label: 'Well Ingredient pH',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Pre Mixed Concentration': {
      label: 'Well Ingredient Pre Mixed Concentration',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Short Name': {
      label: 'Well Ingredient Short Name',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Type': {
      label: 'Well Ingredient Type',
      group: 'Well Ingredient',
    },
    'Well Ingredient.Volume': {
      label: 'Well Ingredient Volume',
      group: 'Well Ingredient',
    },

    'Well.Column Number': {
      label: 'Well Column Number',
      group: 'Well',
    },
    'Well.ID': {
      label: 'Well ID',
      group: 'Well',
    },
    'Well.Number': {
      label: 'Well Number',
      group: 'Well',
    },
    'Well.Row Letter': {
      label: 'Well Row Letter',
      group: 'Well',
    },
    'Well.Volume': {
      label: 'Well Volume',
      group: 'Well',
    },
    'Well.Water Volume': {
      label: 'Well Water Volume',
      group: 'Well',
    },
  },
} as const;
